module.exports = __webpack_public_path__ + "static/media/gl_logo.d8aa5356.png";


//////////////////
// WEBPACK FOOTER
// ./src/modules/NTICore/assets/img/gl_logo.png
// module id = 184
// module chunks = 0